var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.75c0 2.278-.923 4.34-2.416 5.834A8.224 8.224 0 0 1 11 22a8.224 8.224 0 0 1-5.834-2.416A8.224 8.224 0 0 1 2.75 13.75c0-2.278.923-4.34 2.416-5.834 0 0 5.834 3.84 5.834-7.916 0 0 8.25 6.462 8.25 13.75Z",
    fill: "#FF5C39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 15.157c0 1.13-.462 2.153-1.208 2.894A4.128 4.128 0 0 1 11 19.25c-1.14 0-2.17-.459-2.917-1.2a4.064 4.064 0 0 1-.692-4.877c.928 1.814 4.64 2.433 4.64-3.823 0 0 3.094 2.737 3.094 5.807Z",
    fill: "#FFA245"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b44442bf.svg";
export { ForwardRef as ReactComponent };